
<app-block-header [breadcrumb]="newData"></app-block-header>
 <ng-template #sidebar>
    <app-product-sidebar class="block-split__item block-split__item-sidebar col-auto"></app-product-sidebar>
</ng-template>

<div class="block-split" [class.block-split--has-sidebar]="layout === 'sidebar'" *ngIf="data">
    <div class="container">
        <div class="block-split__row row no-gutters">
            <ng-container *ngIf="layout === 'sidebar' && sidebarPosition === 'start'">
                <ng-container *ngTemplateOutlet="sidebar"></ng-container>
            </ng-container>
            <div class="block-split__item block-split__item-content col-auto">
                <div
                    class="product"
                    [class.product--layout--full]="layout === 'full'"
                    [class.product--layout--sidebar]="layout === 'sidebar'"
                >
                    <div class="product__body">
                        <div class="product__card product__card--one"></div>
                        <div class="product__card product__card--two"></div>

                        <app-product-gallery  class="product__gallery" [images]="data.cover_image" [layout]="galleryLayout"></app-product-gallery>

                        <div class="product__header">
                            <h1 class="product__title">{{ data.name }}</h1>

                            <div class="product__subtitle">
                                <div class="product__rating">
                                    <div class="product__rating-stars">
                                        <app-rating [value]="5"></app-rating>
                                    </div>

                                </div>


                            </div>
                         </div>
                        <div class="product__main">
                            <div class="product__excerpt" >
                                {{ data.information }}

                            </div>
                        </div>
                        <div class="product__info">
                            <div class="product__info-card" >
                                <div class="product__info-body">
                                    <div class="product__prices-stock">
                                        <div class="product__prices">
                                            <h3 class="card-title">Enquiry Form</h3>
                                                <form [formGroup]="enquiryForm" (ngSubmit)="submitForm(0)">
                                                    <div class="form-group">
                                                        <label >Name</label>
                                                        <input

                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Your Name"
                                                            formControlName="name"
                                                        >
                                                        <div class="invalid-feedback">
                                                            <div >
                                                                This Field is required.
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label >Email</label>
                                                        <input

                                                            type="email"
                                                            class="form-control"
                                                            placeholder="Enter Your Email"
                                                            formControlName="email"
                                                        >
                                                        <div class="invalid-feedback">
                                                            <div >
                                                                This Field is required.
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label >Number</label>
                                                        <input

                                                            type="number"
                                                            class="form-control"
                                                            placeholder="Enter Phone Number"
                                                            formControlName="phone_no"
                                                        >
                                                        <div class="invalid-feedback">
                                                            <div >
                                                                This Field is required.
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label >Message</label>
                                                        <textarea

                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Message"
                                                            formControlName="message"
                                                        ></textarea>
                                                        <div class="invalid-feedback">
                                                            <div>
                                                                This Field is required.
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="form-group mb-5">
                                                        <button
                                                            type="submit"
                                                            class="btn btn-primary mt-2 "

                                                        >
                                                            Submit
                                                        </button>


                                                    </div>

                                                </form>

                                        </div>

                                    </div>

                                </div>





                            </div>


                        </div>
                        <app-product-tabs class="product__tabs" [layout]="layout" #tabs>
                            <app-product-tab id="product-tab-description" label="About Us">
                                <div class="typography" [innerHTML]="data.about_us"></div>
                            </app-product-tab>


                            <app-product-tab id="product-tab-analogs" label="Courses" *ngIf="data.courses_fees_set?.length != 0">
                                <app-analogs-table [course]="data.courses_fees_set" [productId]="data.id"></app-analogs-table>
                            </app-product-tab>
                            <app-product-tab id="product-tab-gallery" label="Gallery" *ngIf="data.newImage?.length != 0">
                                <app-product-gallery  [images]="data.newImage" ></app-product-gallery>
                            </app-product-tab>
                        </app-product-tabs>
                    </div>
                </div>


            </div>
            <ng-container *ngIf="layout === 'sidebar' && sidebarPosition === 'end'">
                <ng-container *ngTemplateOutlet="sidebar"></ng-container>
            </ng-container>
        </div>
    </div>
